module.exports = __webpack_public_path__ + "img/Monte_Kope_58.4df2561e.jpg";